export default __webpack_public_path__ + "static/sign-f26f06438415bb11f06d65cdb8b1a00c.jpg";